import { render, staticRenderFns } from "./ScreenshotControl.vue?vue&type=template&id=d345b84e&"
import script from "./ScreenshotControl.vue?vue&type=script&lang=js&"
export * from "./ScreenshotControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports